var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"editable-element",class:[_vm.attrs.className != null ? _vm.attrs.className : ''],style:([
        _vm.translate != null ? { translate: _vm.translate } : '',
        _vm.attrs.heightElem != null ? !isNaN(_vm.attrs.heightElem) ? { height: _vm.attrs.heightElem + 'px' }  : { height: _vm.attrs.heightElem } : '', 
        _vm.attrs.widthElem != null ? !isNaN(_vm.attrs.widthElem) ? { width: _vm.attrs.widthElem + 'px' }  : { width: _vm.attrs.widthElem } : '',
        {position: 'absolute'}
    ]),attrs:{"src":_vm.attrs.src[_vm.attrs.isLang ? _vm.attrs.isLang : 0],"id":_vm.id,"alt":"Dummy"},on:{"click":function($event){return _vm.clickElement($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }